import { render, staticRenderFns } from "./PastDisputesViewFooter.vue?vue&type=template&id=654e19de&scoped=true&"
import script from "./PastDisputesViewFooter.vue?vue&type=script&lang=js&"
export * from "./PastDisputesViewFooter.vue?vue&type=script&lang=js&"
import style0 from "./PastDisputesViewFooter.vue?vue&type=style&index=0&id=654e19de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e19de",
  null
  
)

export default component.exports